module.exports = require("core-js-pure/features/object/get-prototype-of");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/object/get-prototype-of.js
// module id = 620
// module chunks = 0